/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ContractBinderDto
 */
export interface ContractBinderDto {
    /**
     * 
     * @type {string}
     * @memberof ContractBinderDto
     */
    contractId: string;
    /**
     * 
     * @type {string}
     * @memberof ContractBinderDto
     */
    binderId: string;
}

/**
 * Check if a given object implements the ContractBinderDto interface.
 */
export function instanceOfContractBinderDto(value: object): value is ContractBinderDto {
    if (!('contractId' in value) || value['contractId'] === undefined) return false;
    if (!('binderId' in value) || value['binderId'] === undefined) return false;
    return true;
}

export function ContractBinderDtoFromJSON(json: any): ContractBinderDto {
    return ContractBinderDtoFromJSONTyped(json, false);
}

export function ContractBinderDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContractBinderDto {
    if (json == null) {
        return json;
    }
    return {
        
        'contractId': json['contractId'],
        'binderId': json['binderId'],
    };
}

export function ContractBinderDtoToJSON(json: any): ContractBinderDto {
    return ContractBinderDtoToJSONTyped(json, false);
}

export function ContractBinderDtoToJSONTyped(value?: ContractBinderDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'contractId': value['contractId'],
        'binderId': value['binderId'],
    };
}

